import * as React from 'react'
import cn from 'classnames'
import { CheckinStatusLabelVm } from './checkin-status-label-vm'

export type CheckinStatus = string | null

export type CheckinStatusLabelProps = {
  status: CheckinStatus
  statusColor?: string | null
  statusLabel?: string | null
}

export const CheckinStatusLabel: React.VFC<CheckinStatusLabelProps> = (
  props
) => {
  const { status, statusColor, statusLabel } = props

  const vm = new CheckinStatusLabelVm(status, statusLabel, statusColor)

  return (
    <div className="bg-white border-b border-l border-r border-t border-gray-200 border-solid rounded w-max">
      <span
        className={cn(
          'align-self-start level-text-label py-0.5 whitespace-nowrap blob',
          { 'not-checked-in': status === 'not_checked_in' }
        )}
        style={
          vm.ratingColor
            ? ({ '--rating-color': vm.ratingColor } as React.CSSProperties)
            : undefined
        }
      >
        {vm.text}
      </span>
    </div>
  )
}
